import Vue from 'vue';
import store from './../../store';
import creditNoteProductTransformer from './../../transformers/creditNoteProduct';

const success = ({ data }, resolve) => {
  const creditNoteProducts = creditNoteProductTransformer.fetchCollection(data.data);

  store.dispatch('fetchAllCreditNoteProducts', creditNoteProducts);
  resolve(creditNoteProducts);
};

const failed = (error, reject) => reject(error);

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/credit_notes/${id}/products`)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/creditNoteProduct/all.js